import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(
    private loaderService: LoaderService,
    private authenticationService: AuthenticationService
    ) { }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // 檔案類型的 request 不顯示 loader
    if (request.responseType === 'blob') {
      return next.handle(request);
    }

    // 取得 json 檔案之要求，不加入 laoding 的計算
    if (/\.json$/i.test(request.url)) {
      return next.handle(request);
    }

    // refreshToken時不讀取loader
    if (this.authenticationService.inRefreshProcess === true ){
      return next.handle(request);
    }

    this.loaderService.start();
    return next.handle(request).pipe(
      finalize(() => {
        this.loaderService.stop();
      })
    );
  }
}
